module.exports = __webpack_public_path__ + "static/media/residential.44ea3b65.svg";